// store.js
import { createStore } from "vuex";
import account from "../api/account.js";
import logger from "@/global/logger.js";

export default createStore({
  state: {
    isUserValidated: false, // 假设初始状态为未登录
    user: null, // 用户信息对象，可能包含userId和token等字段
    logs: [],
    activeTab: 0, // 当前激活的tab索引
  },
  mutations: {
    setActiveTab(state, index) {
      state.activeTab = index;
    },
    addLog(state, log) {
      state.logs.push(log);
    },
    setLoginStatus(state, isValidated) {
      state.isUserValidated = isValidated;
    },
    setUser(state, user) {
      state.user = user;
      // 可以在这里将userId和token保存到localStorage，但通常我们在actions中做这件事
      localStorage.setItem("userId", user.userId);
      localStorage.setItem("token", user.token);
      localStorage.setItem("name", user.name);
    },
    resetLoginStatus(state) {
      state.isUserValidated = false;
      state.user = null;
      // 清除localStorage中的用户信息
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      localStorage.removeItem("name");
    },
  },
  actions: {
    log({ commit }, message) {
      commit("addLog", message);
    },
    async login({ commit }, [userId, token, name]) {
      try {
        commit("setLoginStatus", true);
        commit("setUser", { userId, token, name }); // 假设你有一个mutation来设置用户信息
      } catch (error) {
        console.error("Login error:", error);
      }
    },
    async checkAuthStatus({ commit }) {
      if (this.state.isUserValidated) {
        return true;
      }

      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");
      const name = localStorage.getItem("name");
      logger.log("token: " + token);

      if (!token) return false;

      const validateResult = await account.validateUser(userId, token);
      const isValid = validateResult.isValid;
      if (isValid) {
        commit("setLoginStatus", true);
        commit("setUser", { userId, token, name });
        return true;
      } else {
        commit("setLoginStatus", false);
        return false;
      }
    },
    logout({ commit }) {
      // 登出逻辑
      commit("resetLoginStatus");
    },
  },
  getters: {
    logs: (state) => state.logs,
  },
});
